import styled from 'styled-components';

import { Div, FlexRow, H2 } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';

export const InfoCardSectionHeader = styled(H2)`
  border-bottom: 1px solid ${colors.nickel};
`;

export const Body = styled(Div)`
  display: inline-block;
  vertical-align: top;
`;

export const Info = styled(FlexRow)`
  width: 50%;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    width: 100%;
  }
`;
